import { render, staticRenderFns } from "./CustomVirtualScrollerSelectList.vue?vue&type=template&id=047d365a&scoped=true"
import script from "./CustomVirtualScrollerSelectList.vue?vue&type=script&lang=ts"
export * from "./CustomVirtualScrollerSelectList.vue?vue&type=script&lang=ts"
import style0 from "./CustomVirtualScrollerSelectList.vue?vue&type=style&index=0&id=047d365a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d365a",
  null
  
)

export default component.exports